import { z } from 'zod';
import { STANDARDIZED_LABEL_SCOPE } from '../constnats/standardizedLabels';

const standardizedLabelIdSchema = z.string().or(z.number());

export type StandardizedLabelIdType = z.infer<typeof standardizedLabelIdSchema>;

export const standardizedLabelNameSchema = z.string().min(1, 'Standardized label name is required').trim();

export const standardizedLabelScopeSchema = z.nativeEnum(STANDARDIZED_LABEL_SCOPE);

export const standardizedLabelTagsSchema = z.array(z.string());

export const standardizedLabelSchema = z.object({
    id: standardizedLabelIdSchema,
    name: standardizedLabelNameSchema,
    scope: standardizedLabelScopeSchema,
    tags: standardizedLabelTagsSchema,
    createdOn: z.string(),
    updatedOn: z.string(),
});

export type StandardizedLabelType = z.infer<typeof standardizedLabelSchema>;

export const standardizedLabelCreationSchema = standardizedLabelSchema.pick({
    scope: true,
    name: true,
    tags: true,
});
export type StandardizedLabelCreationSchemaType = z.infer<typeof standardizedLabelCreationSchema>;

export const standardizedLabelUpdateSchema = standardizedLabelSchema.pick({
    scope: true,
    name: true,
    tags: true,
});
export type StandardizedLabelUpdateSchemaType = z.infer<typeof standardizedLabelUpdateSchema>;

export const recommendationsFiltersSchema = z.object({
    schemaId: z.string(),
    descriptorId: z.string(),
});

export type RecommendationsFiltersType = z.infer<typeof recommendationsFiltersSchema>;

const standardizedLabelRelationDescriptorSchema = z.object({
    descriptorLabel: z.string(),
});

const standardizedLabelRelationSchemaRelationSchema = z.object({
    companyId: z.number().int().positive(),
    companyName: z.string(),
    schemaId: z.number().int().positive(),
    schemaName: z.string(),
    descriptors: z.array(standardizedLabelRelationDescriptorSchema),
});

export const standardizedLabelRelationSchema = z.object({
    standardizedLabelId: z.number().int().positive(),
    standardizedLabelName: z.string(),
    schemaRelations: z.array(standardizedLabelRelationSchemaRelationSchema),
});

export const standardizedLabelRelationsSchema = z.array(standardizedLabelRelationSchema);
export type StandardizedLabelRelationsType = z.infer<typeof standardizedLabelRelationsSchema>;
